import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-new-photo-not-approved',
  templateUrl: './new-photo-not-approved.component.html',
  styleUrls: ['./new-photo-not-approved.component.scss'],
})
export class NewPhotoNotApprovedComponent  implements OnInit {

  constructor(private modalCtrl: ModalController,
    public translate: TranslateService,
  ) { }

  ngOnInit() {}


  ToUse(){
    this.modalCtrl.dismiss('toUse');
  }


  discard(){
    this.modalCtrl.dismiss('discart');
  }


  goBack(){
    this.modalCtrl.dismiss('discart')
  }
}
